import React from "react";

interface ChecklistItemResult {
  result_id: number;
  status: string;
  tested_at: string;
  researcher?: {
    user_id: number;
    username: string;
    display_name: string;
    email?: string;
  } | null;
}

interface CollaborativeResultsProps {
  item: {
    all_results?: any[];
  };
}

const CollaborativeResults: React.FC<CollaborativeResultsProps> = ({ item }) => {
  const results = item.all_results || [];
  if (results.length === 0) return null;

  return (
    <div className="flex items-center gap-2">
      <div className="flex -space-x-1.5">
        {results.map((result) => {
          const res = result.researcher;
          if (!res) return null;
          const status = result.status;
          const statusColor = 
            status === "COMPLETED" ? 'bg-emerald-500' : 
            status === "FAILED" ? 'bg-red-500' : 'bg-slate-400';
          
          return (
            <div 
              key={result.result_id}
              className="relative group/avatar hover:z-20"
            >
              <div 
                className="inline-block h-6 w-6 rounded-full ring-2 ring-white bg-blue-50 flex items-center justify-center text-[9px] font-black text-blue-600 border border-blue-100 shadow-sm cursor-pointer"
              >
                {(res.display_name || res.username).substring(0, 2).toUpperCase()}
                {/* Status Dot */}
                <div className={`absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-white ${statusColor}`} />
              </div>
              
              {/* Tooltip Content */}
              <div className="absolute bottom-full left-0 mb-2 w-max px-2 py-1.5 bg-slate-900 text-white text-[9px] rounded-lg opacity-0 group-hover/avatar:opacity-100 transition-all pointer-events-none z-50 shadow-2xl border border-slate-700/50 whitespace-nowrap scale-90 group-hover/avatar:scale-100 origin-bottom-left">
                <div className="font-bold border-b border-white/10 pb-1 mb-1 flex items-center gap-1.5">
                  <div className="w-1 h-1 rounded-full bg-blue-400"></div>
                  {res.display_name || res.username}
                </div>
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-1">
                    <span className={`w-1.5 h-1.5 rounded-full ${statusColor}`} />
                    <span className="font-black uppercase tracking-widest text-[8px]">
                      {status === "COMPLETED" ? "PASS" : status === "FAILED" ? "FAIL" : "N/A"}
                    </span>
                  </div>
                  {result.tested_at && (
                    <span className="text-[8px] text-slate-400 font-medium">
                      {new Date(result.tested_at).toLocaleDateString()}
                    </span>
                  )}
                </div>
                <div className="absolute top-full left-3 -translate-x-1/2 border-[4px] border-transparent border-t-slate-900"></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CollaborativeResults;
